import { Theme, createStyles, withStyles } from '@material-ui/core/styles';

import {
  Accordion,
  AccordionActions,
  AccordionActionsProps,
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
} from '@material-ui/core';

export const NotificationDisclosure = withStyles((_theme: Theme) =>
  createStyles({
    root: {
      boxShadow: 'none',
      borderBottom: '1px solid rgba(0,0,0,.12)',
      '&:before': {
        display: 'none',
      },
      width: '100%',
      backgroundColor: 'inherit',
    },
    expanded: {
      margin: 'auto !important',
    },
  }),
)((props: AccordionProps) => <Accordion {...props} />);

export const NotificationDisclosureSummary = withStyles((_theme: Theme) =>
  createStyles({
    root: {},
    content: {
      flexDirection: 'column',
    },
  }),
)((props: AccordionSummaryProps) => <AccordionSummary {...props} />);

export const NotificationDisclosureDetails = withStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      paddingTop: theme.spacing(1.5),
    },
  }),
)((props: AccordionDetailsProps) => <AccordionDetails {...props} />);

export const NotificationDisclosureAction = withStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(4),
    },
  }),
)((props: AccordionActionsProps) => <AccordionActions {...props} />);
